import React, { lazy, Suspense } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import { Toaster } from "./components/ui/sonner";
import { HotelProvider } from "./context/HotelContext";
import { AuthProvider } from "./context/AuthContext";
import HotelGuard from "./components/HotelGuard";
import PrivateRoute from "./components/PrivateRoute";

const Home = lazy(() => import("./pages/Home"));
const About = lazy(() => import("./pages/About"));
const Gallery = lazy(() => import("./pages/Gallery"));
const Rooms = lazy(() => import("./pages/Rooms"));
const Packages = lazy(() => import("./pages/Packages"));
const Explore = lazy(() => import("./pages/Explore"));
const Login = lazy(() => import("./pages/Login"));
const Register = lazy(() => import("./pages/Register"));
const MyBookings = lazy(() => import("./pages/MyBookings"));
const BookingDetailPage = lazy(() => import("./pages/BookingDetailPage"));
const Tickets = lazy(() => import("./pages/Tickets"));
const TicketPrintPage = lazy(() => import("./pages/TicketPrintPage"));

function App() {
  return (
    <BrowserRouter>
      <HotelProvider>
        <HotelGuard>
          <AuthProvider>
            <Suspense fallback={null}>
              <Routes>
                {/* Main app with layout */}
                <Route path="/*" element={
                  <div className="App">
                    <ScrollToTop />
                    <Header />
                    <main className="min-h-screen">
                      <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/gallery" element={<Gallery />} />
                        <Route path="/rooms" element={<Rooms />} />
                        <Route path="/packages" element={<Packages />} />
                        <Route path="/explore" element={<Explore />} />
                        <Route path="/login" element={<Login />} />
                        <Route path="/register" element={<Register />} />
                        <Route path="/my-bookings" element={<MyBookings />} />
                        <Route path="/my-bookings/:bookingId" element={<BookingDetailPage />} />
                        <Route path="/tickets" element={<Tickets />} />
                        <Route path="/tickets/order/:orderRef" element={<PrivateRoute><TicketPrintPage /></PrivateRoute>} />
                      </Routes>
                    </main>
                    <Footer />
                    <Toaster />
                  </div>
                } />
              </Routes>
            </Suspense>
          </AuthProvider>
        </HotelGuard>
      </HotelProvider>
    </BrowserRouter>
  );
}

export default App;
